var mixin = {
  data() {
    return {
      errors: false
    }
  },
  methods: {
    errorMessages(field) {
      return (this.errors && this.errors[field]) ? this.errors[field] : []
    },
    showFirstErrorMessage() {
      const errorValues = Object.values(this.errors)

      return (this.errors && errorValues.length && errorValues[0].length) ? errorValues[0][0] : 'Something went wrong.'
    }
  }
}

export default mixin;
